import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { updateConditionActiveOptionAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import applyTextVariantsForConditionOperation from './applyTextVariantsForConditionOperation';
import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const updateConditionActiveOptionOperation =
  (address: ConditionAddress, optionId: string) => (dispatch: ThunkDispatch) => {
    batch(() => {
      dispatch(updateConditionActiveOptionAction({ address, optionId }));
      // Swap any per-option text variants that reference this condition — they
      // can live on any spread, and each affected spread re-packs its reflow.
      const recomputed = dispatch(applyTextVariantsForConditionOperation(address.conditionId, optionId));
      // Recompute for the CONDITION'S spread, not the viewer's current one: a
      // design-scoped picklist (showOnAllSpreads) is operable while the buyer
      // is looking at a different page. Skipped when the variant swap already
      // re-packed it — computeReflowState walks the whole spread.
      if (!recomputed.has(address.spreadIndex)) {
        dispatch(updateHiddenElementsOperation(address.spreadIndex));
      }
    });
  };

export default updateConditionActiveOptionOperation;
